import { cn } from "../cn.js";
import { PRODUCT_NAME } from "../brand.js";

export function KeyMark({ className, title = PRODUCT_NAME }: { className?: string; title?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 320 320"
			className={cn("shrink-0", className)}
			role="img"
			aria-label={title}
		>
			<g fill="#3f3f46">
				<rect x="0" y="0" width="80" height="80" />
				<rect x="160" y="0" width="80" height="80" />
				<rect x="80" y="80" width="80" height="80" />
				<rect x="240" y="80" width="80" height="80" />
				<rect x="0" y="160" width="80" height="80" />
				<rect x="160" y="160" width="80" height="80" />
				<rect x="80" y="240" width="80" height="80" />
				<rect x="240" y="240" width="80" height="80" />
			</g>
		</svg>
	);
}
